import { calcShouldDisableEntity } from "./calcShouldDisableEntity";
import { filterEntitiesByExtensions } from "./filterEntitiesByExtensions";
import { EntityPickerModalEntity } from "../types";

export const processEntities = ({
  entities,
  disabledTooltip,
  forbiddenRootFolderName,
  forbiddenExtensions,
  extensionsToFilter,
}: {
  entities: EntityPickerModalEntity[];
  disabledTooltip: string;
  forbiddenRootFolderName: string;
  forbiddenExtensions: string[];
  extensionsToFilter: string[];
}) => {
  const filteredEntities = filterEntitiesByExtensions(
    entities,
    extensionsToFilter
  );
  return filteredEntities.map((entity: any) => {
    return calcShouldDisableEntity(
      entity,
      disabledTooltip,
      forbiddenRootFolderName,
      forbiddenExtensions
    );
  });
};
